module.exports = __webpack_public_path__ + "static/media/Robot.86256ea3.png";